import {
  customizedReservationResponseType,
  customizeReservationInputType,
} from "utils";
import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

export async function postCustomizeReservation(
  value: customizeReservationInputType
) {
  const formData = new FormData();
  formData.append("reservationId", value.reservationId);
  if (value.audioSettings) {
    formData.append("audioSettings", JSON.stringify(value.audioSettings));
  }
  if (value.greetingsMessageFile && value.greetingsMessageFile[0]) {
    formData.append("greetingsMessageFile", value.greetingsMessageFile[0]);
  }
  if (value.teaserVideoFile && value.teaserVideoFile[0]) {
    formData.append("teaserVideoFile", value.teaserVideoFile[0]);
  }
  if (value.greetingsVideoBuildId) {
    formData.append("greetingsVideoBuildId", value.greetingsVideoBuildId);
  }
  if (value.teaserVideoBuildId) {
    formData.append("teaserVideoBuildId", value.teaserVideoBuildId);
  }
  if (value.greetingsMessageMaxDuration != null) {
    formData.append(
      "greetingsMessageMaxDuration",
      value.greetingsMessageMaxDuration.toString()
    );
  }
if (value.idleInactivityTimeoutSeconds != null) {
  formData.append(
    "idleInactivityTimeoutSeconds",
    value.idleInactivityTimeoutSeconds.toString()
  );
}
  return axiosFetch.post("/api/ReservationCustomization/upsert", formData);
}

export async function getCustomizedReservation(
  reservationId: string
): Promise<customizedReservationResponseType> {
  return axiosFetch.safeGet(`/api/ReservationCustomization/${reservationId}`);
}

export async function getGreetingsMessageFile(reservationId: string) {
  return axiosFetch.get(
    `/api/ReservationCustomization/greetingsMessage/${reservationId}`,
    { responseType: "blob" }
  );
}

export async function getTeaserFile(reservationId: string) {
  return axiosFetch.get(
    `/api/ReservationCustomization/teaserVideo/${reservationId}`,
    { responseType: "blob" }
  );
}
